export const getDataObject = async (system, omsId) => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  const baseApiPath = system.expConfiguration['base-api-url'];
  let dataObject;

  /* This is for local dev if call is down */
  // return dataObject = mockData;

  // https://stage-custom.hd-qa74.homedepotdev.com/pipfigurator/PageData/api/v1/320340139
  try {
    const response = await system.fetch(`${baseApiPath}/pipfigurator/PageData/api/v1/${omsId}`, requestOptions);
    if (response) {
      dataObject = {
        config: {
          ...response?.settings,
          title: response?.meta?.title || '',
          pageDescription: response?.meta?.pageDescription || '',
          categoryName: response?.meta?.categoryName || '',
          siteName: response?.meta?.siteName || '',
          breadcrumbs: response?.thdBreadcrumbInfo?.thdBreadcrumbs || [],
          isAddtoBundleDisabled: false,
          isCopy: false,
          omsId,
        },
        product: {
          details: { ...response?.product },
        },
      };
    } else {
      dataObject = {
        config: { omsId },
        product: { details: {} },
      };
    }
  } catch (error) {
    dataObject = {
      config: { omsId, errorMessage: error },
      product: { details: {} },
    };
  }

  return dataObject;
};
